import axios from "axios";
import { environment } from "../../environments/environment";
import { SellerTypes } from "./User.types";

const API_BASE_NAME = `${environment.apiBaseUrl}`;

const authHeader = () => ({
  headers: {
    Authorization: `Bearer ${localStorage.getItem("token")}`,
  },
});

// ✅ Get All Sellers
export const getAllSellers = async (): Promise<SellerTypes[]> => {
  const res = await axios.get(`${API_BASE_NAME}/admin/allsellers`);
  return res.data.data;
};

export const getSellerById = async (sellerId: number): Promise<SellerTypes> => {
  const res = await axios.get(`${API_BASE_NAME}/admin/seller/${sellerId}`);
  return res.data.data;
};

// ✅ Get All Buyers
export const getAllBuyers = async (): Promise<SellerTypes[]> => {
  const res = await axios.get(`${API_BASE_NAME}/buyers`);
  return res.data.data;
};

// ✅ Get Seller By ID
export const getSellerForVerification = async (
  sellerId: number
): Promise<SellerTypes> => {
  const res = await axios.get(`${API_BASE_NAME}/seller/get/${sellerId}`);
  return res.data.data;
};

// ✅ Approve Seller
export const approveSeller = async (sellerId: number) => {
  const res = await axios.put(
    `${API_BASE_NAME}/seller/${sellerId}/approved`,
    {},
    authHeader()
  );
  return res.data;
};

// ❌ Reject Seller
export const rejectSeller = async (sellerId: number, reason: string) => {
  const res = await axios.put(
    `${API_BASE_NAME}/seller/${sellerId}/reject`,
    { reason },
    authHeader()
  );
  return res.data;
};